// extracted by mini-css-extract-plugin
export default {"connectWallet":"ConnectWallet_connectWallet__1VvnT"};